import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  acceptsAlphas: (
    <FormattedMessage
      id="Global.AcceptsAlphas"
      defaultMessage="Accepts Alphas"
    />
  ),
  advancedFilters: (
    <FormattedMessage
      id="Global.AdvancedFilters"
      defaultMessage="Advanced Filters"
    />
  ),
  carrier: <FormattedMessage id="Global.Carrier" defaultMessage="Carrier" />,
  class: <FormattedMessage id="Global.Class" defaultMessage="Route Class" />,
  clear: (
    <FormattedMessage id="Global.ClearFilters" defaultMessage="Clear Filters" />
  ),
  loading: <FormattedMessage id="Global.Loading" defaultMessage="Loading" />,
  priority: <FormattedMessage id="Global.Priority" defaultMessage="Priority" />,
  provider: <FormattedMessage id="Global.Provider" defaultMessage="Provider" />,
  routeId: <FormattedMessage id="Global.RouteId" defaultMessage="Route Id" />,
  routeName: (
    <FormattedMessage id="Global.RouteName" defaultMessage="Route Name" />
  ),
  search: <FormattedMessage id="Global.Search" defaultMessage="Search" />,
  status: <FormattedMessage id="Global.Status" defaultMessage="Route Status" />,
  type: <FormattedMessage id="Global.Type" defaultMessage="Route Type" />,
};

export default FormattedMessages;
